<template>
  <!-- 添加/编辑客户信息 -->
  <dialogModel
    :title="AddEditor == 1 ? '编辑' : '添加一家'"
    width="720px"
    :visible.sync="dialogAdd"
    @handleClose="handleShutDown"
    @handleOk="handleVerify"
  >
    <div class="main-body add-customer-body">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="168px"
        class="demo-ruleForm"
      >
        <el-form-item
          label="企业类型："
          prop="EnterpriseType"
          :required="true"
        >
          <el-radio-group
            v-model="ruleForm.EnterpriseType"
            :disabled="AddEditor == 1 && row.status == 0"
          >
            <el-radio
              v-for="item in Arr"
              :key="'et-' + item.id"
              :label="item.id"
              >{{ item.name }}</el-radio
            >
          </el-radio-group>
        </el-form-item>

        <el-form-item
          label="纳税类型："
          prop="PayTaxesType"
          :required="true"
        >
          <el-radio-group
            v-model="ruleForm.PayTaxesType"
            :disabled="AddEditor == 1 && row.status == 0"
          >
            <el-radio
              v-for="item in Arr1"
              :key="'pt-' + item.id"
              :label="item.id"
              >{{ item.name }}</el-radio
            >
          </el-radio-group>
        </el-form-item>

        <el-form-item label="企业名称：" prop="firm" :required="true">
          <el-input
            maxlength="30"
            v-model="ruleForm.firm"
            placeholder="请输入企业名称"
          ></el-input>
        </el-form-item>

        <el-form-item
          label="统一社会信用代码："
          prop="code"
          :required="true"
        >
          <el-input
            maxlength="30"
            v-model="ruleForm.code"
            placeholder="请输入统一社会信用代码"
            :disabled="AddEditor == 1 && row.status == 0"
          ></el-input>
        </el-form-item>

        <el-form-item
          label="法定代表人(负责人)："
          prop="name"
          :required="true"
        >
          <el-input
            maxlength="30"
            v-model="ruleForm.name"
            placeholder="请输入法定代表人(负责人)"
          ></el-input>
        </el-form-item>

        <el-form-item label="联系电话：" prop="phone" :required="true">
          <el-input
            maxlength="30"
            v-model="ruleForm.phone"
            placeholder="请输入联系电话"
          ></el-input>
        </el-form-item>

        <el-form-item label="地区：" prop="idAddressCode" :required="true">
          <div class="region-row">
            <el-select
              v-model="idProvinceCode"
              placeholder="省"
              class="region-select"
              @change="provinceChange"
            >
              <el-option
                v-for="item in provinceList"
                :key="item.code"
                :label="item.label"
                :value="item.code"
              >
              </el-option>
            </el-select>
            <el-select
              v-model="idMarketCode"
              placeholder="市"
              class="region-select"
              @change="marketChange"
            >
              <el-option
                v-for="item in idMarketList"
                :key="item.code"
                :label="item.label"
                :value="item.code"
              >
              </el-option>
            </el-select>
            <el-select
              v-model="ruleForm.idAddressCode"
              placeholder="区"
              class="region-select"
            >
              <el-option
                v-for="item in idCountyList"
                :key="item.code"
                :label="item.label"
                :value="item.code"
              >
              </el-option>
            </el-select>
          </div>
        </el-form-item>

        <el-form-item label="地址：" prop="address" :required="true">
          <el-input
            maxlength="30"
            v-model="ruleForm.address"
            placeholder="请输入地址"
          ></el-input>
        </el-form-item>

        <el-form-item label="开户银行名称：" prop="bankName" :required="false">
          <el-input
            maxlength="30"
            v-model="ruleForm.bankName"
            placeholder="请输入开户银行名称"
          ></el-input>
        </el-form-item>

        <el-form-item label="开户银行账号：" prop="bankNum" :required="false">
          <el-input
            maxlength="30"
            v-model="ruleForm.bankNum"
            placeholder="请输入开户银行账号"
          ></el-input>
        </el-form-item>

        <el-form-item
          label="电子税务局密码："
          prop="Taxation"
          :required="false"
        >
          <el-input
            maxlength="30"
            v-model="ruleForm.Taxation"
            placeholder="填写电子税务局密码，则代表已授权于平台"
          ></el-input>
        </el-form-item>

        <el-form-item label="备注：" class="remark-item">
          <el-input
            type="textarea"
            placeholder="请填写备注，若被列入风险纳税人，请及时说明情况，若没有说明情况，自身承担风险"
            v-model="ruleForm.Note"
            maxlength="1500"
            show-word-limit
            resize="none"
            :rows="4"
          >
          </el-input>
        </el-form-item>

        <div class="form-tip">
          注：电子税务局密码用于平台处理企业服务，请勿透漏给平台以外的他人
        </div>
      </el-form>
    </div>
  </dialogModel>
</template>

<script>
import * as API from "@/assets/api/Agency/Enterprise.js";
import * as API1 from "@/assets/api/firm/firmTalent.js";
export default {
  props: {
    dialogAdd: {},
    AddEditor: {}, //0添加 1编辑
    row: {},
  },
  components: {},
  data() {
    return {
      rules: {
        EnterpriseType: [
          {
            required: true,
            message: "请选择企业类型",
            trigger: ["blur", "change"],
          },
        ],
        PayTaxesType: [
          {
            required: true,
            message: "请选择纳税类型",
            trigger: ["blur", "change"],
          },
        ],
        firm: [
          {
            required: true,
            message: "请输入企业名称",
            trigger: ["blur", "change"],
          },
        ],
        code: [
          {
            required: true,
            message: "请输入统一社会信用代码",
            trigger: ["blur", "change"],
          },
          {
            pattern: /^[0-9A-HJ-NPQRSTUWXY]{18}$/,
            required: true,
            message: "请输入有效的18位统一社会信用代码",
            trigger: ["blur", "change"],
          },
        ],
        name: [
          {
            required: true,
            message: "请输入法人姓名",
            trigger: ["blur", "change"],
          },
        ],
        phone: [
          {
            required: true,
            message: "请输入手机号码",
            trigger: ["blur", "change"],
          },
          {
            required: true,
            message: "请输入正确的手机号码",
            trigger: ["blur", "change"],
            pattern: /^\s*1[3-9]\d{9}\s*$/,
          },
        ],
        address: [
          {
            required: true,
            message: "请输入地址",
            trigger: ["blur", "change"],
          },
        ],
        bankNum: [
          {
            pattern: /^\d{16,22}$/,
            message: "开户账号需为16-22位纯数字",
            trigger: ["blur", "change"],
          },
        ],
        idAddressCode: [
          {
            required: true,
            message: "请选择地区",
            trigger: ["blur", "change"],
          },
        ],
      },
      ruleForm: {
        firm: "",
        code: "",
        name: "",
        address: "",
        phone: "",
        Note: "",
        EnterpriseType: 0,
        PayTaxesType: 0,
        Taxation: "",
        bankName: "",
        bankNum: "",
        idAddressCode: "",
      },
      provinceList: [],
      idProvinceCode: "",
      idMarketList: [],
      idMarketCode: "",
      idCountyList: [],
      Arr: [
        { id: 0, name: "有限公司" },
        { id: 1, name: "个体户" },
        { id: 2, name: "子公司" },
        { id: 3, name: "分公司" },
        { id: 4, name: "其他" },
      ],
      Arr1: [
        { id: 0, name: "小规模纳税人" },
        { id: 1, name: "一般纳税人" },
      ],
    };
  },
  watch: {
    dialogAdd: {
      handler(newSs) {
        if (newSs == true && this.AddEditor == 0) {
          this.resetForm();
        } else if (newSs == true && this.AddEditor == 1) {
          for (var i in this.provinceList) {
            for (var k in this.provinceList[i].children) {
              for (var s in this.provinceList[i].children[k].children) {
                if (
                  this.provinceList[i].children[k].children[s].code ==
                  this.row.companyAddressCode
                ) {
                  this.idProvinceCode = this.provinceList[i].code;
                  this.idMarketList = this.provinceList[i].children;
                  this.idMarketCode = this.provinceList[i].children[k].code;
                  this.idCountyList = this.provinceList[i].children[k].children;
                }
              }
            }
          }
          this.ruleForm = {
            firm: this.row.companyName,
            code: this.row.creditCode,
            name: this.row.legalPerson,
            address: this.row.companyAddress,
            phone: this.row.phone,
            Note: this.row.remark,
            EnterpriseType: this.row.companyType,
            PayTaxesType: this.row.taxType,
            Taxation: this.row.eTaxPassword,
            bankName: this.row.bankName,
            bankNum: this.row.bankAccount,
            idAddressCode: this.row.companyAddressCode,
          };
        } else if (newSs == false) {
          this.resetForm();
        }
      },
      immediate: false,
    },
  },
  computed: {},
  created() {
    const addressList = this.$store.getters.getAddRes;
    if (addressList && addressList.length > 0) {
      this.provinceList = addressList.filter(
        (p) => p && p.label !== "全国" && String(p.code) !== "001"
      );
    } else {
      this.getAddressSelect();
    }
  },
  destroyed() {},
  methods: {
    resetForm() {
      this.ruleForm = {
        firm: "",
        code: "",
        name: "",
        address: "",
        phone: "",
        Note: "",
        EnterpriseType: 0,
        PayTaxesType: 0,
        Taxation: "",
        bankName: "",
        bankNum: "",
        idAddressCode: "",
      };
      this.idProvinceCode = "";
      this.idMarketList = [];
      this.idMarketCode = "";
      this.idCountyList = [];
      this.$nextTick(() => {
        if (this.$refs.ruleForm) {
          this.$refs.ruleForm.clearValidate();
        }
      });
    },
    getAddressSelect() {
      API1.getAddressSelect().then((res) => {
        this.provinceList = res.data;
      });
    },
    provinceChange(val) {
      const province = this.provinceList.find((p) => p.code == val);
      this.idMarketList =
        province && province.children ? province.children : [];
      this.idMarketCode = "";
      this.idCountyList = [];
      this.ruleForm.idAddressCode = "";
    },
    marketChange(val) {
      const city = this.idMarketList.find((p) => p.code == val);
      this.idCountyList = city && city.children ? city.children : [];
      this.ruleForm.idAddressCode = "";
    },
    handleShutDown() {
      this.resetForm();
      this.$emit("handleShutDown");
    },
    handleVerify() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.AddEditor == 0) {
            var data = {
              data: {
                companyName: this.ruleForm.firm,
                creditCode: this.ruleForm.code,
                phone: this.ruleForm.phone,
                taxType: this.ruleForm.PayTaxesType,
                companyType: this.ruleForm.EnterpriseType,
                legalPerson: this.ruleForm.name,
                companyAddress: this.ruleForm.address,
                eTaxPassword: this.ruleForm.Taxation,
                bankName: this.ruleForm.bankName,
                bankAccount: this.ruleForm.bankNum,
                remark: this.ruleForm.Note,
                companyAddressCode: this.ruleForm.idAddressCode,
              },
            };
            API.addCompanyCustomers(data).then((res) => {
              if (res.code == 0) {
                this.$tool.PromptBox("success", "操作成功");
                this.$emit("handleVerify");
              }
            });
          } else {
            var data = {
              data: {
                id: this.row.id,
                companyName: this.ruleForm.firm,
                creditCode: this.ruleForm.code,
                phone: this.ruleForm.phone,
                taxType: this.ruleForm.PayTaxesType,
                companyType: this.ruleForm.EnterpriseType,
                legalPerson: this.ruleForm.name,
                companyAddress: this.ruleForm.address,
                eTaxPassword: this.ruleForm.Taxation,
                bankName: this.ruleForm.bankName,
                bankAccount: this.ruleForm.bankNum,
                remark: this.ruleForm.Note,
                companyAddressCode: this.ruleForm.idAddressCode,
              },
            };
            API.editCompanyCustomers(data).then((res) => {
              if (res.code == 0) {
                this.$tool.PromptBox("success", "操作成功");
                this.$emit("handleVerify");
              }
            });
          }
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
@import "../../Bookkeeping/components/bookkeeping-form-dialog.less";

.add-customer-body {
  max-width: 640px;
  margin: 0 auto;

  /* 长标签「法定代表人(负责人)」需要更宽标签列 */
  /deep/ .el-form-item__label {
    width: 168px !important;
    flex: 0 0 168px !important;
  }

  /deep/ .el-radio-group {
    display: flex !important;
    flex-wrap: wrap;
    white-space: normal;
  }

  .region-row {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    gap: 8px;
    max-width: 360px;
  }

  /deep/ .region-select {
    width: 114px !important;
    max-width: none !important;
  }

  .remark-item {
    /deep/ .el-textarea {
      width: 360px !important;
      max-width: 100%;
    }
  }

  .form-tip {
    margin: 0 0 8px 168px;
    font-size: 12px;
    color: #999999;
    line-height: 1.5;
  }
}
</style>
